import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { API } from './constants';
import { PaginationInput } from '../store/types';

export type CreateBeneficiaryInput = {
  alias: string;
  account_beneficiary: string;
  account_number: string;
  is_internal: boolean;
};

export type GetBeneficiariesDto = {
  search?: string;
  account_number?: string;
  service_id?: string;
};

@Injectable({ providedIn: 'root' })
export class BeneficiaryService extends ApiService {
  getBeneficiaries(pagination: PaginationInput, dto: GetBeneficiariesDto) {
    return this.post(`${API.getBeneficiaries}`, {
			body: { pagination: { ...pagination, sortBy: 'alias', sortOrder: 'ASC' }, dto }
    });
  }

  createBeneficiary(beneficiaryData: CreateBeneficiaryInput) {
    return this.post<any>(`${API.createBeneficiary}`, { body: beneficiaryData });
  }

  deleteBeneficiary(beneficiaryId: string) {
    return this.delete<any>(`${API.deleteBeneficiary}/${beneficiaryId}`);
  }
}
